"use client";
import { useState, useCallback, startTransition } from "react";
import { useRouter } from "next/navigation";
import { runIdle } from "@/src/utils/idle-utils";

import { getGa4SearchEventParams } from "src/helpers/google-tag-manager/event-helpers/search";
import { formGTMEventGA4 } from "src/helpers/google-tag-manager/common";

import Input from "components/common/input";
import Button from "components/common/button";

import styles from "./styles.module.css";

const ListingIdPanel = () => {
  const router = useRouter();
  const [value, setValue] = useState("");
  const [isMessage, setIsMessage] = useState(false);

  const handleChange = useCallback((event) => {
    setIsMessage(false);
    const result = event.target.value.replace(/\D/g, "");
    setValue(result);
  }, []);

  const handleSearchClick = useCallback(() => {
    const criteriaFreeText = {
      freetext: {
        value,
      },
    };

    const ga4SearchEventParams = getGa4SearchEventParams({
      btnCategory: "search",
      criteriaState: criteriaFreeText,
      activeTab: "",
    });

    if (value !== "") {
      runIdle(() => {
        formGTMEventGA4({ eventName: "search", eventParameters: ga4SearchEventParams });
      }, 1000);

      startTransition(() => {
        router.push(`/ilan/${value}`);
      });
    } else {
      setIsMessage(true);
    }
  }, [value, router]);

  const handleKeyPress = useCallback(
    (e) => {
      if (e.code === "Enter") {
        handleSearchClick();
      }
    },
    [handleSearchClick]
  );
  return (
    <div className={styles.tabpanel}>
      <div className={styles.field}>
        <span className={styles.title}>İlan No</span>
        <div className={styles.input}>
          <Input
            value={value}
            onChange={handleChange}
            placeholder="İlan numarasını giriniz"
            onKeyPress={handleKeyPress}
          />
          {isMessage && <div className={styles.dangerMessage}>Lütfen ilan numarası giriniz.</div>}
        </div>
      </div>
      <div className={`${styles.field} h-full flex items-end`}>
        <div className={styles.searchbutton}>
          <Button onClick={handleSearchClick} size="Auto">
            Ara
          </Button>
        </div>
      </div>
    </div>
  );
};

ListingIdPanel.propTypes = {};

export default ListingIdPanel;
